import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=40f9a9bd&scoped=true&"
import script from "./StepTitle.vue?vue&type=script&lang=ts&"
export * from "./StepTitle.vue?vue&type=script&lang=ts&"
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=40f9a9bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9a9bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40f9a9bd', component.options)
    } else {
      api.reload('40f9a9bd', component.options)
    }
    module.hot.accept("./StepTitle.vue?vue&type=template&id=40f9a9bd&scoped=true&", function () {
      api.rerender('40f9a9bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/StepTitle.vue"
export default component.exports